import { FeatureFlags } from 'src/types/feature-flag';

import { useAuthContext } from '../../context/AuthContextProvider';

export function useFeatureFlag(flagName: keyof FeatureFlags): boolean {
  const { auth } = useAuthContext();
  return (
    !!auth.user?.featureFlags?.[flagName as keyof FeatureFlags]?.active ||
    !!auth.user?.featureFlags?.[flagName as keyof FeatureFlags]?.global
  );
}
